// @ts-nocheck
// TODO: tighten types after migration
import React from "react";

type PaginationControlsProps = {
  currentPage: number;
  totalPages: number;
  onPrevious: () => void;
  onNext: () => void;
  onFirst?: () => void;
  onLast?: () => void;
  previousDisabled?: boolean;
  nextDisabled?: boolean;
  containerClassName?: string;
  buttonClassName?: string;
  infoClassName?: string;
  previousLabel?: string;
  nextLabel?: string;
  renderInfo?: (currentPage: number, totalPages: number) => React.ReactNode;
};

export default function PaginationControls(props: PaginationControlsProps) {
  const {
    currentPage,
    totalPages,
    onPrevious,
    onNext,
    onFirst,
    onLast,
    previousDisabled,
    nextDisabled,
    containerClassName = "pagination",
    buttonClassName,
    infoClassName,
    previousLabel = "Previous",
    nextLabel = "Next",
    renderInfo,
  } = props;

  const canGoPrevious = previousDisabled ?? currentPage <= 1;
  const canGoNext = nextDisabled ?? currentPage >= totalPages;

  // Internal style for First/Last buttons as requested
  const extremeBtnStyle = {
    background: 'none',
    border: 'none',
    padding: '0 8px',
    cursor: 'pointer',
    fontSize: '0.65rem', // 40% smaller than previous ~0.85rem-1rem sizes
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'color 0.2s ease',
    color: 'inherit',
    lineHeight: '1.1',
    textAlign: 'left',
    flexShrink: 0
  };

  const iconStyleCommon = {
    fontSize: '1rem', // Scale icon down as well
    display: 'flex',
    alignItems: 'center'
  };

  return (
    <div className={containerClassName}>
      {onFirst && (
        <button 
          onClick={onFirst} 
          disabled={canGoPrevious} 
          style={extremeBtnStyle}
          className="pagination-nav-extreme-btn first-pg-btn group"
        >
          <i className="fi fi-br-angle-double-small-left" style={{ ...iconStyleCommon, marginRight: '4px' }}></i>
          <span className="opacity-80 font-medium">First <span className="mobile-br">page</span></span>
        </button>
      )}
      <button className={buttonClassName} disabled={canGoPrevious} onClick={onPrevious} style={{ lineHeight: '1.2', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: 'fit-content' }}>
        <span className="text-center px-1">Previous <span className="mobile-br">page</span></span>
      </button>
      <span className={infoClassName}>
        {renderInfo ? renderInfo(currentPage, totalPages) : `Page ${currentPage} of ${totalPages}`}
      </span>
      <button className={buttonClassName} disabled={canGoNext} onClick={onNext} style={{ lineHeight: '1.2', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: 'fit-content' }}>
        <span className="text-center px-1">Next <span className="mobile-br">page</span></span>
      </button>
      {onLast && (
        <button 
          onClick={onLast} 
          disabled={canGoNext} 
          style={{ ...extremeBtnStyle, textAlign: 'right' }}
          className="pagination-nav-extreme-btn last-pg-btn group"
        >
          <span className="opacity-80 font-medium">Last <span className="mobile-br">page</span></span>
          <i className="fi fi-br-angle-double-small-right" style={{ ...iconStyleCommon, marginLeft: '4px' }}></i>
        </button>
      )}
      <style dangerouslySetInnerHTML={{ __html: `
        .pagination-nav-extreme-btn:hover:not(:disabled) {
          color: #47b5ff !important;
        }
        .pagination-nav-extreme-btn:disabled {
          opacity: 0.3;
          cursor: not-allowed;
        }
        .mobile-br {
          display: inline;
        }
        @media (max-width: 480px) {
          .mobile-br {
            display: block;
          }
          .pagination-nav-extreme-btn {
            font-size: 0.55rem !important;
            padding: 0 4px !important;
          }
          .pagination-nav-extreme-btn i {
            font-size: 1.1rem !important;
            margin: 0 !important;
          }
          .pagination-nav-extreme-btn span {
            display: none !important;
          }
          .${buttonClassName} {
            font-size: 0.75rem !important;
            padding: 4px 6px !important;
            height: auto !important;
            min-width: 0 !important;
          }
          /* Ensure the container doesn't overflow */
          .${containerClassName} {
            display: flex;
            flex-wrap: nowrap !important;
            justify-content: center;
            align-items: center;
            gap: 6px !important;
            width: 100%;
          }
        }
      `}} />
    </div>
  );
}
